export const formatReservationTime = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleTimeString('lt-LT', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
};

export const formatReservationDate = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleDateString('lt-LT', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};
